import React, { useRef } from "react";
import CardBody from "../../../components/Card/CardBody";
import Card from "../../../components/Card/Card";
import { Grid } from "@mui/material";
import TranslationWrapper, { getTranslation } from "../../../components/TranslationWrapper/TranslationWrapper";
import { connect } from "react-redux";
import Button from "../../../components/CustomButtons/Button";
import { Add, Edit } from "@mui/icons-material";
import NewAdditionalInvoiceLine from "../Dialogs/NewAdditionalInvoiceLine";
import { useDialog } from "../../../licensing/utils/DialogProvider";
import JamezzTable from "../../../components/JamezzTable/JamezzTable";
import EditAdditionalInvoiceLine from "../Dialogs/EditAdditionalInvoiceLine";
import { useParams } from "react-router";
import { format, parse } from "date-fns";

function SubsSubscriptionAdditional(props) {
  const [openDialog] = useDialog();
  const jamezzTable = useRef(null);
  const params = useParams();

  const actions = [
    {
      icon: Edit,
      tooltip: <TranslationWrapper tKey={"Edit"} />,
      action: (row) => {
        openDialog({
          children: (
            <EditAdditionalInvoiceLine
              SubsSubscriptionAdditionalLineId={row[0]}
              onSaved={() => {
                jamezzTable.current?.refreshData();
              }}
            />
          ),
          fullWidth: true,
          maxWidth: "md",
        });
      },
    },
  ];

  return (
    <Card>
      <CardBody>
        <h3>
          <TranslationWrapper tKey={"Additional items to be invoiced"} />
        </h3>
        <Grid container>
          <JamezzTable
            actions={actions}
            dataMapping={[
              { dbfield: "id", editable: false },
              { dbfield: "type", editable: false },
              { dbfield: "order_status", editable: false },
              {
                customData: (subsadd) => {
                  return subsadd;
                },
                customRender: (subsadd) => {
                  return format(parse(subsadd.start_date, "yyyy-MM-dd", new Date()), "dd-MM-yyyy");
                },
              },
              { dbfield: "unit_price", editable: false },
            ]}
            dbfields={"id,start_date,unit_price,type,order_status,status_invoicing"}
            delete={true}
            fetchUrl={"core/subsSubscriptionAdditional"}
            filters={[
              {
                field: "subs_subscription_id",
                operator: "=",
                value: params.id,
              },
            ]}
            headerIcon={null}
            headers={[
              {
                label: getTranslation("#"),
                sortable: true,
                sortKey: "id",
              },
              {
                label: getTranslation("Type"),
              },
              {
                label: getTranslation("Order status"),
              },
              {
                label: getTranslation("Start date"),
              },
              {
                label: getTranslation("Unit price"),
              },
            ]}
            popupCss={{
              position: "absolute",
            }}
            reduxKey={"setSubsSubscriptionAdditional"}
            ref={jamezzTable}
          />
          <Button
            color={"success"}
            onClick={() => {
              openDialog({
                children: (
                  <NewAdditionalInvoiceLine
                    onSaved={() => {
                      jamezzTable.current?.refreshData();
                    }}
                    subscriptionId={params.id}
                  />
                ),
                fullWidth: true,
                maxWidth: "md",
              });
            }}
          >
            <Add />
            <TranslationWrapper tKey={"Add additional items to be invoiced"} />
          </Button>
        </Grid>
      </CardBody>
    </Card>
  );
}

const mapStateToProps = (state) => {
  return {
    venue_id: state.filtersV2.venue_id?.value,
    userLocale: state.user.lang,
  };
};

export default connect(mapStateToProps)(SubsSubscriptionAdditional);
